// we need to import SECONDS_IN_MINUTE directly, not from '~/common',
// otherwise all ~/common will be imported and we cannot use unit tests
import { SECONDS_IN_MINUTE } from '~/src/common/constants';

import type { ExtendedBrightcovePlayer } from '../types';

export function getMediaDurationInSeconds(player: ExtendedBrightcovePlayer): number {
  const rawMediaDuration = player.duration();
  // livestream durations are negative
  const mediaDuration = Math.abs(Math.floor(rawMediaDuration));
  return mediaDuration;
}

export function getTimeInSeconds(player: ExtendedBrightcovePlayer): number {
  const rawCurrentTime = player.currentTime();
  const timeInSec = Math.floor(rawCurrentTime);
  return timeInSec;
}

export function convertSecondsInMinutes(seconds: number): number {
  return Math.round(seconds / SECONDS_IN_MINUTE);
}
export function getMediaDurationInMinutes(player: ExtendedBrightcovePlayer): number {
  const mediaDurationInSec = getMediaDurationInSeconds(player);
  const mediaDurationMinutes = convertSecondsInMinutes(mediaDurationInSec);
  return mediaDurationMinutes;
}

export function getSecondsCompletionPercent(player: ExtendedBrightcovePlayer) {
  const mediaDuration = getMediaDurationInSeconds(player);
  const consumedSeconds = player.consumedSeconds();

  const secondsCompletionPercent = Math.floor((consumedSeconds / mediaDuration) * 100);
  return secondsCompletionPercent;
}
